import { render } from "./BannerPageComponent.vue?vue&type=template&id=c74f5874&scoped=true"
import script from "./BannerPageComponent.vue?vue&type=script&lang=js"
export * from "./BannerPageComponent.vue?vue&type=script&lang=js"

import "./BannerPageComponent.vue?vue&type=style&index=0&id=c74f5874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74f5874"]])

export default __exports__